import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { QUESTION_RELEASE_CACHED_REPOSITORY, QUESTION_RELEASES_REPOSITORY } from '../../core';
import { QUESTION_RELEASES_API } from '../data-sources';
export var QuestionReleasesWebRepository = /*#__PURE__*/function () {
  function QuestionReleasesWebRepository(questionReleasesApi, questionReleaseCached) {
    _classCallCheck(this, QuestionReleasesWebRepository);

    this.questionReleasesApi = questionReleasesApi;
    this.questionReleaseCached = questionReleaseCached;
  }

  _createClass(QuestionReleasesWebRepository, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var cachedQuestions, responseOrError, questionListResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cachedQuestions = this.questionReleaseCached.findByQuery(query);

                if (!(cachedQuestions !== undefined)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok(cachedQuestions));

              case 3:
                _context.next = 5;
                return this.questionReleasesApi.get(query);

              case 5:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 8:
                questionListResponse = responseOrError.getValue();
                this.questionReleaseCached.saveByQuery(query, questionListResponse);
                return _context.abrupt("return", Result.ok(questionListResponse));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }]);

  return QuestionReleasesWebRepository;
}();
export var questionReleasesWebRepositoryProvider = {
  provide: QUESTION_RELEASES_REPOSITORY,
  useFactory: function useFactory(questionReleasesApi, questionReleaseCached) {
    return new QuestionReleasesWebRepository(questionReleasesApi, questionReleaseCached);
  },
  inject: [QUESTION_RELEASES_API, QUESTION_RELEASE_CACHED_REPOSITORY]
};